export enum StorageKeys {
  token = 'token',
  refreshToken = 'refreshToken',
  sidebarOpened = 'sidebarOpened'
}
